<template>
  <div
    :style="{
      background: 'url(' + showByImg + ')',
    }"
  >
    <!-- <div class="top autoWidth">
      <Language class="float-r" />
      <InOut class="float-r lan" />
    </div>style="position:fixed;top:0;width:100%;z-index:1000;" -->
    <Navigation style="position: fixed; top: 0; width: 100%; z-index: 1000" />
    <!-- <keep-alive>style="padding-top:80px;" -->
    <router-view style="padding-top: 80px" />
    <!-- </keep-alive> -->

    <Footer v-if="showFooter" />
    <LoginType v-if="loginForm" />
    <EmptyAccount v-if="hotGameList" />
    <PayConfirm v-if="payConfirm" />
    <ValidAccount v-if="validAccountForm" />
  </div>
</template>
<script>
import EmptyAccount from "../components/emptyAccount";
import ValidAccount from "../components/validAccount";
import PayConfirm from "../components/payConfirm";
import LoginType from "../components/loginType";
import InOut from "./inOut";
import Language from "./language";

import Navigation from "./navigation";
import Footer from "./footer";
import { mapGetters } from "vuex";
export default {
  name: "index",
  computed: {
    ...mapGetters([
      "hotGameList",
      "loginForm",
      "payConfirm",
      "validAccountForm",
    ]),
  },
  components: {
    InOut,
    Language,
    Navigation,
    Footer,
    LoginType,
    EmptyAccount,
    PayConfirm,
    ValidAccount,
  },
  watch: {
    $route(to, from) {
      let index = ["Index", "Detail"].indexOf(to.name);
      this.showFooter = index < 0 ? true : false;
      let index2 = [
        "Order",
        "Issues",
        "Customer",
        "Recharge",
        "MyGame",
      ].indexOf(to.name);
      this.showByImg =
        index2 < 0
          ? ""
          : "https://sdk-test-1259319615.cos.ap-shanghai.myqcloud.com/gw/game/img/1617702299139_1.jpg";
    },
  },
  data() {
    let index = ["Index", "Detail"].indexOf(this.$route.name);
    let showFooter = index < 0 ? true : false;

    let index2 = ["Order", "Issues", "Customer", "Recharge", "MyGame"].indexOf(
      this.$route.name
    );
    let showByImg =
      index2 < 0
        ? ""
        : "https://sdk-test-1259319615.cos.ap-shanghai.myqcloud.com/gw/game/img/1617702299139_1.jpg";
    return {
      showFooter: showFooter,
      showByImg: showByImg,
    };
  },
};
</script>
<style lang="scss">
// .top {
//   height: 60px;
//   .lan {
//     margin-right: 10px;
//   }
// }
</style>


// WEBPACK FOOTER //
// src/page/index.vue